import { parse, stringify } from "qs"
import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import {
  addIntegration,
  tanstackRouterBrowserTracingIntegration,
} from "@sentry/react"
import { routeTree } from "./routeTree.gen"

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,
    parseSearch: (search) =>
      parse(search, {
        ignoreQueryPrefix: true,
        decoder: (str, defaultDecoder, _charset, type) => {
          const decoded = defaultDecoder(str)

          if (type === "value" && /^-?\d+\.?\d*$/.test(decoded)) {
            const num = Number(decoded)

            return isNaN(num) ? decoded : num
          }

          return decoded
        },
      }),
    stringifySearch: (search) =>
      stringify(search, {
        addQueryPrefix: true,
      }),
  })

  // Name transactions after the matched route (/r/$assignmentId), not the
  // visited URL (/r/01a000d8-…). Raw URLs gave every assignment, brief and
  // tenant its own transaction name, which fragmented performance data and
  // left error issues titled with an id nobody can place — and sent tenant
  // slugs to Sentry, which we mask everywhere else (issue #92).
  // Registered here rather than in initSentry because the instrumentation
  // needs the router instance, which only exists once it is built. Client
  // only: on the server this runs per request, and there is no browser
  // tracing to instrument.
  if (typeof window !== "undefined") {
    addIntegration(tanstackRouterBrowserTracingIntegration(router))
  }

  return router
}
